import { Brand as TypeBrand, createBranded } from '@deltasierra/type-utilities';
import { CountryCode } from '../client';
import { HasId, Auditable } from '../common';

export type CountryId = TypeBrand<number, 'CountryId'>;
export const CountryId = createBranded<CountryId>();

export interface Country extends HasId<CountryId>, Auditable {
    countryCode: CountryCode;
    latitude: number | null;
    longitude: number | null;
}
